import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  lrn: string;
  batchName: string;
  regulate?: boolean;
  amendmentMotivation?: string;
  amendmentReason?: string;
}

export const useGenerateBatchByLrn = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ lrn, batchName, regulate = false, amendmentMotivation, amendmentReason }: HookProps) => {
      const result = await apiClient.declarationsCrud.generateBatchByLrn.mutation({
        params: { lrn },
        body: { batchName, regulate, amendmentMotivation, amendmentReason },
      });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: (_, variables) => {
      // todo: figure out why it takes 5s for the retrieve to return the added values as well
      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: ['batch'] });
        queryClient.invalidateQueries({ queryKey: ['declarations'] });
        queryClient.invalidateQueries({ queryKey: ['declarations-meta'] });
        toast.success(variables.regulate ? 'Regularisation done!' : 'Duplication done!');
      }, 5000);
      queryClient.invalidateQueries({ queryKey: ['declaration'] });
    },
    onError: (error, variables) => {
      showErrorToast(error, variables.regulate ? `Couldn't regulate!` : `Couldn't duplicate!`);
    },
  });
};
